import Modal from '@/app/components/Modal';
import {
  DialogTitle as RadixDialogTitle,
  DialogDescription as RadixDialogDescription
} from '@/components/ui/dialog';

const Dialog = Modal;
const DialogTitle = RadixDialogTitle;
const DialogDescription = RadixDialogDescription;

export { Dialog as default, DialogTitle, DialogDescription };
